export const FETCH_DAILY_BALANCE = 'report/FETCH_DAILY_BALANCE'
export const FETCH_DAILY_BALANCE_SUCCESS = 'report/FETCH_DAILY_BALANCE_SUCCESS'
export const FETCH_DAILY_BALANCE_FAILURE = 'report/FETCH_DAILY_BALANCE_FAILURE'
export const RESET_DAILY_BALANCE = 'report/RESET_DAILY_BALANCE'

export const FETCH_EMPLOYEES_BALANCE = 'report/FETCH_EMPLOYEES_BALANCE'
export const FETCH_EMPLOYEES_BALANCE_SUCCESS = 'report/FETCH_EMPLOYEES_BALANCE_SUCCESS'
export const FETCH_EMPLOYEES_BALANCE_FAILURE = 'report/FETCH_EMPLOYEES_BALANCE_FAILURE'
export const RESET_EMPLOYEES_BALANCE = 'report/RESET_EMPLOYEES_BALANCE'

export const FETCH_CATEGORY_BALANCE = 'report/FETCH_CATEGORY_BALANCE'
export const FETCH_CATEGORY_BALANCE_SUCCESS = 'report/FETCH_CATEGORY_BALANCE_SUCCESS'
export const FETCH_CATEGORY_BALANCE_FAILURE = 'report/FETCH_CATEGORY_BALANCE_FAILURE'
export const RESET_CATEGORY_BALANCE = 'report/RESET_CATEGORY_BALANCE'

export const FETCH_CATEGORY_SELLS_BALANCE = 'report/FETCH_CATEGORY_SELLS_BALANCE'
export const FETCH_CATEGORY_SELLS_BALANCE_SUCCESS = 'report/FETCH_CATEGORY_SELLS_BALANCE_SUCCESS'
export const FETCH_CATEGORY_SELLS_BALANCE_FAILURE = 'report/FETCH_CATEGORY_SELLS_BALANCE_FAILURE'
export const RESET_CATEGORY_SELLS_BALANCE = 'report/RESET_CATEGORY_SELLS_BALANCE'

export const FETCH_RECEIPT_BALANCE = 'report/FETCH_RECEIPT_BALANCE'
export const FETCH_RECEIPT_BALANCE_SUCCESS = 'report/FETCH_RECEIPT_BALANCE_SUCCESS'
export const FETCH_RECEIPT_BALANCE_FAILURE = 'report/FETCH_RECEIPT_BALANCE_FAILURE'
export const RESET_RECEIPT_BALANCE = 'report/RESET_RECEIPT_BALANCE'

export const FETCH_RECEIPT_SELLS_BALANCE = 'report/FETCH_RECEIPT_SELLS_BALANCE'
export const FETCH_RECEIPT_SELLS_BALANCE_SUCCESS = 'report/FETCH_RECEIPT_SELLS_BALANCE_SUCCESS'
export const FETCH_RECEIPT_SELLS_BALANCE_FAILURE = 'report/FETCH_RECEIPT_SELLS_BALANCE_FAILURE'
export const RESET_RECEIPT_SELLS_BALANCE = 'report/RESET_RECEIPT_SELLS_BALANCE'

export const FETCH_PAYMENT_DETAILS_BALANCE = 'report/FETCH_PAYMENT_DETAILS_BALANCE'
export const FETCH_PAYMENT_DETAILS_BALANCE_SUCCESS = 'report/FETCH_PAYMENT_DETAILS_BALANCE_SUCCESS'
export const FETCH_PAYMENT_DETAILS_BALANCE_FAILURE = 'report/FETCH_PAYMENT_DETAILS_BALANCE_FAILURE'
export const RESET_PAYMENT_DETAILS_BALANCE = 'report/RESET_PAYMENT_DETAILS_BALANCE'

export const FETCH_PAYMENT_TYPES_BALANCE = 'report/FETCH_PAYMENT_TYPES_BALANCE'
export const FETCH_PAYMENT_TYPES_BALANCE_SUCCESS = 'report/FETCH_PAYMENT_TYPES_BALANCE_SUCCESS'
export const FETCH_PAYMENT_TYPES_BALANCE_FAILURE = 'report/FETCH_PAYMENT_TYPES_BALANCE_FAILURE'
export const RESET_PAYMENT_TYPES_BALANCE = 'report/RESET_PAYMENT_TYPES_BALANCE'

export const FETCH_OFFER_DETAILS_BALANCE = 'report/FETCH_OFFER_DETAILS_BALANCE'
export const FETCH_OFFER_DETAILS_BALANCE_SUCCESS = 'report/FETCH_OFFER_DETAILS_BALANCE_SUCCESS'
export const FETCH_OFFER_DETAILS_BALANCE_FAILURE = 'report/FETCH_OFFER_DETAILS_BALANCE_FAILURE'
export const RESET_OFFER_DETAILS_BALANCE = 'report/RESET_OFFER_DETAILS_BALANCE'

export const FETCH_SERVICE_DETAILS_BALANCE = 'report/FETCH_SERVICE_DETAILS_BALANCE'
export const FETCH_SERVICE_DETAILS_BALANCE_SUCCESS = 'report/FETCH_SERVICE_DETAILS_BALANCE_SUCCESS'
export const FETCH_SERVICE_DETAILS_BALANCE_FAILURE = 'report/FETCH_SERVICE_DETAILS_BALANCE_FAILURE'
export const RESET_SERVICE_DETAILS_BALANCE = 'report/RESET_SERVICE_DETAILS_BALANCE'

export const FETCH_SERVICE_NAMES_BALANCE = 'report/FETCH_SERVICE_NAMES_BALANCE'
export const FETCH_SERVICE_NAMES_BALANCE_SUCCESS = 'report/FETCH_SERVICE_NAMES_BALANCE_SUCCESS'
export const FETCH_SERVICE_NAMES_BALANCE_FAILURE = 'report/FETCH_SERVICE_NAMES_BALANCE_FAILURE'
export const RESET_SERVICE_NAMES_BALANCE = 'report/RESET_SERVICE_NAMES_BALANCE'

export const FETCH_DAYS_BALANCE = 'report/FETCH_DAYS_BALANCE'
export const FETCH_DAYS_BALANCE_SUCCESS = 'report/FETCH_DAYS_BALANCE_SUCCESS'
export const FETCH_DAYS_BALANCE_FAILURE = 'report/FETCH_DAYS_BALANCE_FAILURE'
export const RESET_DAYS_BALANCE = 'report/RESET_DAYS_BALANCE'

export const FETCH_CUSTOMERS_BALANCE = 'report/FETCH_CUSTOMERS_BALANCE'
export const FETCH_CUSTOMERS_BALANCE_SUCCESS = 'report/FETCH_CUSTOMERS_BALANCE_SUCCESS'
export const FETCH_CUSTOMERS_BALANCE_FAILURE = 'report/FETCH_CUSTOMERS_BALANCE_FAILURE'
export const RESET_CUSTOMERS_BALANCE = 'report/RESET_CUSTOMERS_BALANCE'

export const FETCH_PRODUCT_DETAILS_BALANCE = 'report/FETCH_PRODUCT_DETAILS_BALANCE'
export const FETCH_PRODUCT_DETAILS_BALANCE_SUCCESS = 'report/FETCH_PRODUCT_DETAILS_BALANCE_SUCCESS'
export const FETCH_PRODUCT_DETAILS_BALANCE_FAILURE = 'report/FETCH_PRODUCT_DETAILS_BALANCE_FAILURE'
export const RESET_PRODUCT_DETAILS_BALANCE = 'report/RESET_PRODUCT_DETAILS_BALANCE'

export const FETCH_PRODUCT_NAMES_BALANCE = 'report/FETCH_PRODUCT_NAMES_BALANCE'
export const FETCH_PRODUCT_NAMES_BALANCE_SUCCESS = 'report/FETCH_PRODUCT_NAMES_BALANCE_SUCCESS'
export const FETCH_PRODUCT_NAMES_BALANCE_FAILURE = 'report/FETCH_PRODUCT_NAMES_BALANCE_FAILURE'
export const RESET_PRODUCT_NAMES_BALANCE = 'report/RESET_PRODUCT_NAMES_BALANCE'

export const FETCH_PRODUCTS_IN = 'report/FETCH_PRODUCTS_IN'
export const FETCH_PRODUCTS_IN_SUCCESS = 'report/FETCH_PRODUCTS_IN_SUCCESS'
export const FETCH_PRODUCTS_IN_FAILURE = 'report/FETCH_PRODUCTS_IN_FAILURE'
export const RESET_PRODUCTS_IN = 'report/RESET_PRODUCTS_IN'

export const FETCH_INTERNAL_CONSUMPTION = 'report/FETCH_INTERNAL_CONSUMPTION'
export const FETCH_INTERNAL_CONSUMPTION_SUCCESS = 'report/FETCH_INTERNAL_CONSUMPTION_SUCCESS'
export const FETCH_INTERNAL_CONSUMPTION_FAILURE = 'report/FETCH_INTERNAL_CONSUMPTION_FAILURE'
export const RESET_INTERNAL_CONSUMPTION = 'report/RESET_INTERNAL_CONSUMPTION'

export const FETCH_REGULARIZATIONS = 'report/FETCH_REGULARIZATIONS'
export const FETCH_REGULARIZATIONS_SUCCESS = 'report/FETCH_REGULARIZATIONS_SUCCESS'
export const FETCH_REGULARIZATIONS_FAILURE = 'report/FETCH_REGULARIZATIONS_FAILURE'
export const RESET_REGULARIZATIONS = 'report/RESET_REGULARIZATIONS'

export const FETCH_PRODUCTS_DEVOLUTIONS = 'report/FETCH_PRODUCTS_DEVOLUTIONS'
export const FETCH_PRODUCTS_DEVOLUTIONS_SUCCESS = 'report/FETCH_PRODUCTS_DEVOLUTIONS_SUCCESS'
export const FETCH_PRODUCTS_DEVOLUTIONS_FAILURE = 'report/FETCH_PRODUCTS_DEVOLUTIONS_FAILURE'
export const RESET_PRODUCTS_DEVOLUTIONS = 'report/RESET_PRODUCTS_DEVOLUTIONS'

export const FETCH_INVENTORY = 'report/FETCH_INVENTORY'
export const FETCH_INVENTORY_SUCCESS = 'report/FETCH_INVENTORY_SUCCESS'
export const FETCH_INVENTORY_FAILURE = 'report/FETCH_INVENTORY_FAILURE'
export const RESET_INVENTORY = 'report/RESET_INVENTORY'

export const FETCH_DETAILED_SELLS = 'report/FETCH_DETAILED_SELLS'
export const FETCH_DETAILED_SELLS_SUCCESS = 'report/FETCH_DETAILED_SELLS_SUCCESS'
export const FETCH_DETAILED_SELLS_FAILURE = 'report/FETCH_DETAILED_SELLS_FAILURE'
export const RESET_FETCH_DETAILED_SELLS = 'report/RESET_FETCH_DETAILED_SELLS'





// WEBPACK FOOTER //
// ./src/store/report/actionTypes.js